import React, { useMemo, useEffect } from 'react'
import filterParts from '../../utils/parts/filterParts'
import sortFlatParts from '../../utils/parts/sortFlatParts'
import groupPartsByGroup from '../../utils/parts/groupPartsByGroup'
import groupPartsByArticleBrand from '../../utils/parts/groupPartsByArticleBrand'
import { useDispatch, useSelector } from 'react-redux'
import parts from '../../utils/constants/parts'
import partGroupes from '../../utils/constants/partGroupes'
import { selectFilter, selectIsFilterApplied } from '../../features/filter/filterSlice'
import { selectSort } from '../table/sortSlice'
import ResultTableGrouped from '../table/ResultTableGrouped'
import ResultTableFlat from '../table/ResultTableFlat'
import {
    selectActive as selectIsPaginationActive,
    selectPagination,
    setActive as setPaginationAtive,
    setTotalItems as setTotalPaginationItems,
    selectIsPaginationApplied
} from '../table/pagintaionSlice'
import getPageParts from '../../utils/parts/getPageParts'
import Pagination from '../pagination/Pagination'
import flatParts from '../../utils/parts/flatParts'
import { selectCurrency } from '../currency/currencySlice'
import setPartsPrice from '../../utils/parts/setPartsPrice'
import ReactTooltip from 'react-tooltip'

const SearchResult = () => {
    const dispatch = useDispatch()
    const filter = useSelector(selectFilter)
    const isFilterApplied = useSelector(selectIsFilterApplied)
    const isPaginationApplied = useSelector(selectIsPaginationApplied)
    const sort = useSelector(selectSort)
    const isPaginationActive = useSelector(selectIsPaginationActive)
    const pagination = useSelector(selectPagination)

    useEffect(() => {
        ReactTooltip.rebuild()
    })

    const currency = useSelector(selectCurrency)
    const partsWithCurrency = useMemo(() => setPartsPrice(parts, currency), [currency])

    const filteredParts = useMemo(
        () => filterParts(partsWithCurrency, filter, currency),
        [partsWithCurrency, filter, currency]
    )

    const groupedByGroupParts = useMemo(() => groupPartsByGroup(filteredParts), [filteredParts])

    const groupedByArticleBrandParts = useMemo(
        () => groupPartsByArticleBrand(groupedByGroupParts),
        [groupedByGroupParts]
    )

    const groupesByArticleBrandCnt = Object.values(groupedByArticleBrandParts).reduce(
        (sum, item) => {
            sum += item.length
            return sum
        },
        0
    )

    dispatch(setTotalPaginationItems(groupesByArticleBrandCnt))

    const pageGroupedByArticleBrandParts = isPaginationActive
        ? getPageParts(groupedByArticleBrandParts, pagination)
        : groupedByArticleBrandParts

    if (filteredParts.length === 0) {
        return <div className="article-not-found">Запчасти не найдены!</div>
    }

    return (
        <>
            {partGroupes.map((partGroup) => {
                const type = partGroup.type
                const isSortApplied = sort[type].sortBy

                let ResultTableType = ''
                let parts = []

                if (isSortApplied) {
                    dispatch(setPaginationAtive(false))

                    parts = flatParts(pageGroupedByArticleBrandParts[type])

                    const sortedParts = sortFlatParts(parts, sort[type])
                    parts = sortedParts

                    ResultTableType = ResultTableFlat
                } else {
                    parts = pageGroupedByArticleBrandParts[type]
                    ResultTableType = ResultTableGrouped
                }

                if (!parts.length) {
                    if (!isFilterApplied && !isPaginationApplied && partGroup.show_no_parts_msg) {
                        const isNotFound = partGroup.lang.table.no_parts==='Запрошенного артикула не найдено'
                        return (
                            <div key={type} className={'article-not-found ' + (isNotFound ? 'small' : '')}>
                                {partGroup.lang.table.no_parts}
                            </div>
                        )
                    }

                    return <div key={type} />
                }

                return (
                    <ResultTableType
                        key={type + (isSortApplied ? '_flat' : '_grouped')}
                        parts={parts}
                        title={partGroup.lang.table.title}
                        type={type}
                    />
                )
            })}
            <ReactTooltip
                id="tooltip_part_zero_price"
                place="top"
                type="dark"
                effect="solid"
                multiline={true}
            >
                <span>
                    Просим уточнить цену на
                    <br /> товар у менеджера по
                    <br /> телефону
                </span>
            </ReactTooltip>

            {isPaginationActive && <Pagination />}
        </>
    )
}

export default SearchResult
